import { CurbZonesQuery } from "@/types/gql/graphql";
import { Feature, Polygon } from "geojson";

export type Update = {
  userId: string;
  at: Date;
};

export type CurbZone = Feature<Polygon> & Omit<CurbZonesQuery["curbZones"][number], "id"> & { id?: string };

export const EditableCurbZoneLayerName = "draw-curb-zone-layer";
export const CurbZonePolygonLayerName = "curb-zone-polygon-layer";
